import keyCodes from '@/utils/key-codes';

const SELECTOR = 'vjs-file-upload';

const FILE_OUTPUT_CLASS = '-uploaded';
const IMAGE_FILE_TYPES = new RegExp('image/(jp(e?)g|png)$', 'i');

class FileUpload {
    constructor(el) {
        this.el = el;
        this.toggleEl = document.getElementById(this.el.dataset.toggle);
        this.inputEl = document.getElementById(this.el.dataset.input);
        this.outputEl = document.getElementById(this.el.dataset.output);

        this.hasOutput = !!this.outputEl;
        this.imgOutput = this.outputEl?.nodeName === 'IMG';
        this.imgSrcCache = null;
        this.outputClass = this.el.dataset.outputClass || FILE_OUTPUT_CLASS;

        this.file = null;

        if(this.inputEl) {
            this.init();
        }
    }

    init() {
        this.setupListeners();
    }

    destroy() {
        this.destroyListeners();
    }

    setupListeners() {
        this.toggleEl?.addEventListener('keyup', this.bindedToggle);
        this.inputEl.addEventListener('change', this.bindedInput);
    }

    destroyListeners() {
        this.toggleEl?.removeEventListener('keyup', this.bindedToggle);
        this.inputEl.removeEventListener('change', this.bindedInput);
    }

    toggle(evt) {
        if(evt.which === keyCodes.ENTER || evt.which === keyCodes.SPACE) {
            evt.preventDefault();
            this.inputEl.click();
        }
    }

    input(evt) {
        this.file = evt.target.files[0] || null;

        if(!this.file) {
            this.toggleOutputClass();
        }

        this.update();
    }

    update() {
        if(this.hasOutput) {
            if(!this.imgOutput) {
                this.outputFileName();
            } else {
                this.outputFileImage();
            }
        }
    }

    outputFileName() {
        if(this.file) {
            this.outputEl.textContent = this.file.name;
        } else {
            this.outputEl.textContent = '';
        }
    }

    outputFileImage() {
        if(this.file) {
            if(IMAGE_FILE_TYPES.test(this.file.type)) {
                this.imgSrcCache = this.outputEl.src;
                this.outputEl.src = URL.createObjectURL(this.file);
                this.toggleOutputClass();
            }
        } else if(this.imgSrcCache) {
            this.outputEl.src = this.imgSrcCache;
        }
    }

    toggleOutputClass() {
        if(this.file) {
            this.outputEl.classList.add(this.outputClass);
        } else {
            this.outputEl.classList.remove(this.outputClass);
        }
    }

    // binded listener functions for easy removal
    bindedToggle = this.toggle.bind(this)
    bindedInput = this.input.bind(this);
}

let instanceArr = [];

export function destroy() {
    instanceArr.forEach(instance => instance?.destroy());
    instanceArr.splice(0, instanceArr.length);
}

export default function() {
    const elements = document.querySelectorAll(`[${SELECTOR}]`);
    elements?.forEach((element, i) => {
        instanceArr[i] = new FileUpload(element);
    });
}
